
export const environment = {
    //API_URL: 'https://lab.padraocolor.com', //HOMOLOG
    API_URL: 'https://lord.padraocolor.com', // PROD
    API_TOKEN_DEFAULT: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb2RpZ28iOjU3NX0.EbOdmP4T6j3exdk8YiLKG_86StglUm4OXQYqPawtaVo',
    API_TOKEN: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb2RpZ28iOjU3NX0.EbOdmP4T6j3exdk8YiLKG_86StglUm4OXQYqPawtaVo'
}